import React from "react";
import Scrollbar from "react-perfect-scrollbar-z";

// Vertical scroll box with a thin custom scrollbar. Replaces react-scrollbar
// (which uses findDOMNode, removed in React 19) and keeps its markup classes:
// `scrollarea <className>` on the box and `scrollarea-content <contentClassName>`
// around the children, so existing styles still apply. The look is in
// assets/scss/shared/scrollarea/_scrollarea.scss.
//
// react-scrollbar's `speed` and `horizontal` props are ignored: every caller
// used speed 0.8 and vertical scrolling only.
function ScrollArea({ className = "", contentClassName = "", children }) {
    return (
        <Scrollbar
            className={`scrollarea ${className}`.trim()}
            // Let the page scroll on once the box reaches its end, as before.
            wheelStop={false}
            // Re-measure when the content changes (e.g. a list loads).
            effectData={children}
        >
            <div className={`scrollarea-content ${contentClassName}`.trim()}>{children}</div>
        </Scrollbar>
    );
}

export default ScrollArea;
